import React from "react";
import PropTypes from "prop-types";
import { InfoIcon } from "../Icons";

const Notification = ({
    icon,
    type,
    title,
    children,
    customClass,
    ...rest
}) => {
    return (
        <div
            className={`notification notification__${type} ${customClass}`}
            {...rest}
        >
            {icon && (
                <div className="notification__icon">
                    {React.isValidElement(icon) ? (
                        icon
                    ) : (
                        <InfoIcon className="default-icon" />
                    )}
                </div>
            )}
            <div className="notification__content">
                {title && <span className="notification__title">{title}</span>}
                {children && (
                    <div className="notification__description">{children}</div>
                )}
            </div>
        </div>
    );
};

Notification.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
    type: PropTypes.oneOf(["danger", "success", "warning", "basic"]),
    title: PropTypes.string,
    customClass: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

Notification.defaultProps = {
    icon: false,
    type: "success",
    customClass: "",
};

export default Notification;
